<template>
    <div class="wp_copyrightAreaContainer">
      <div class="container wp_maxWidth1800">
        <div class="row m-0">
          <div class="col-12 col-lg-8 wp_footerIconsAlignment">
            <ul v-if="data.copyrightAreaLinks">
              <li v-for="(link,key) in data.copyrightAreaLinks" :key="key">
                <router-link
                  :to="$t(link.path)" :target="$t(link.target)"
                >
                  <span >

                <img :src="$t(link.iconImage)"/>
                  </span>
                  {{$t(link.text)}}
                </router-link>
              </li>

            </ul>
          </div>

          <div class="col-12 col-lg-4 text-center">
            <div class="iconnect">
              <p>{{$t(data.poweredByText)}}</p>
              <a :href="$t(data.poweredByRedirectUrl)">
                <img
                  :src="$t(data.poweredByLogo)"
                  :alt="$t(data.poweredByLogoAltText)"
                  srcset
                />
              </a>
            </div>
          </div>
        </div>
        <div class="row m-0">
          <div class="col-12">
              <!-- use %% instead of year -->
            <p
              id="copyright"
              class="text-center"
            >{{copyRightText}}</p>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
export default {
	props: {
		// data from cms
		data: {
			type: Object
		}
	},
	computed: {
		// updates the copyright text with current year.
		copyRightText () {
			let data = this.$t(this.data.copyRightText)
			if (data) {
				let date = new Date().getFullYear()
				data = data.replace(/%%/g, date)
			}
			return data
		}

	}

}
</script>
